import { Server } from '@wm/sal';
import Cookies from 'js-cookie';
import { HideLoginScreen, ShowLoginScreen } from '../screens/Login/actions/LoginActions';
import {
  LOGOUT_REDIRECT,
  BASE_SERVICE,
  AUTH_SERVICE,
  JWT_COOKIE_NAME,
  JWT_COOKIE_DOMAIN,
} from './envVariables';

const DEFAULT_REQUEST_TIMEOUT = 30000; // 30 seconds.

const readTokenFromStorage = () => Cookies.get(JWT_COOKIE_NAME);

const writeTokenToStorage = (token: string) =>
  Cookies.set(JWT_COOKIE_NAME, token, { domain: JWT_COOKIE_DOMAIN, path: '/', expires: 365 * 5 });

export const Logout = () => {
  Cookies.remove(JWT_COOKIE_NAME, { domain: JWT_COOKIE_DOMAIN, path: '/' });
  window.location.href = LOGOUT_REDIRECT; // location.reload needs 'location' as its this.
};

Server.config = {
  basePath: window['env'].REACT_APP_API_BASE_PATH, // REACT_APP_API_BASE_PATH is an environment variable
  hideLoginScreen: HideLoginScreen,
  showLoginScreen: ShowLoginScreen,
  readTokenFromStorage,
  writeTokenToStorage,
  defaultTimeout: DEFAULT_REQUEST_TIMEOUT,
  createSessionWith: Server.post(`${BASE_SERVICE}${AUTH_SERVICE}authentication/session`).public(
    true
  ),
  updateTokenWith: Server.put(`${BASE_SERVICE}${AUTH_SERVICE}authentication/token`).public(true),
};

export default Server;
